import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import './SearchInput.css';
import { useTranslations } from '../../../hooks/use-translations.hook';
import { useDynamicInputWidth } from '../../../hooks/use-dynamic-input-width';

export const SearchInput = ({
    className = '',
    inputClassName = '',
    placeholderText = '',
    showClearButton = true,
    onSearchQueryChange,
    onFocus,
    focusOnSearchActivation = false,
}) => {
    const { searchActive } = useSelector(state => state.casino.currentGame);
    const [searchQuery, setSearchQuery] = useState('');
    const [clearButtonVisible, setClearButtonVisible] = useState(false);
    const inputRef = useRef(null);
    const { t } = useTranslations();

    const placeholder = placeholderText.length > 0 ? placeholderText : t('gameNameOrProvider');

    const inputWidth = useDynamicInputWidth(inputRef, placeholder);

    useEffect(() => {
        if (focusOnSearchActivation && searchActive && inputRef) {
            inputRef.current.focus();
        }
    }, [focusOnSearchActivation, searchActive, inputRef]);

    // signal on input value change
    useEffect(() => {
        onSearchQueryChange(searchQuery);
        setClearButtonVisible(searchQuery.length > 0);
    }, [searchQuery]);

    const onChangeHandler = (e) => {
        setSearchQuery(e.target.value);
    };

    const clearQuery = () => {
        setSearchQuery('');
    };

    return (
        <div className={`${className} asg-search-input`}>
            <div className="asg-search-input__icon" />
            <input
                ref={inputRef}
                className={`${inputClassName} asg-search-input__control`}
                type="text"
                placeholder={placeholder}
                onChange={onChangeHandler}
                onFocus={() => { onFocus && onFocus(true); }}
                onBlur={() => { onFocus && onFocus(false); }}
                value={searchQuery}
                style={{ width: inputWidth }}
            />
            {showClearButton && clearButtonVisible && <button
                className="asg-search-input__clear"
                onClick={clearQuery}
            />}
        </div>
    );
};
